import type {
  RequestTutorial,
  TutorialResponse,
} from "src/service/TutorialApi/types";
import { serverApi } from "src/service/serverApi";

export const tutorialapi = serverApi.injectEndpoints({
  endpoints: (builder) => {
    return {
      getTutorial: builder.query<TutorialResponse, void>({
        providesTags: ["Tutoreails"],
        query: () => {
          return {
            method: "get",
            url: `tutorials/status`,
          };
        },
      }),
      patchTutorial: builder.mutation<TutorialResponse, RequestTutorial>({
        invalidatesTags: ["Tutoreails"],
        query: (body) => {
          return {
            body: body,
            method: "PATCH",
            url: `tutorials/status`,
          };
        },
      }),
    };
  },
});

export const { useGetTutorialQuery, usePatchTutorialMutation } = tutorialapi;
